import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-report-name',
  templateUrl: './../../../templates/forms/modals/report-name.component.html',

})
export class ReportNameComponent implements OnInit {

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;
  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "ReportNameListGrid";
  reportSubmenuID = 'HR_2150';
  reportNameList: any[] = [];

  constructor(
    private dataService: DataLoadService,
    public langService: LangService,
    public gridService: GridService
  ) {
    this.colObj = [
      { headerName: langService.langData.reportName, field: 'SUBMENU_NAME_USER', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.descr, field: 'DESCR', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.reportNo, field: 'SUBMENU_ID', sortable: true, resizable: true, hide: false },
    ];
  }
  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.load('FG_SA_COMM_REPORT_LIST', JSON.parse(JSON.stringify({ P_SUBMENU_ID: this.reportSubmenuID }))).subscribe(results => {
      this.reportNameList = results.body; 
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }


}
